import React, { Component } from 'react';
import { isEmpty, map } from 'lodash';
import {
  normalizeAmount,
} from '../../../../utils/transformer.util';
import {
  Button, Select, Input, SelectMultiple,
} from '../../../../components/base/index';
import { errorAlert } from '../../../../utils/alert.util';
import './select.css';

export default class CreateInvoiceKelas extends Component {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this._onRemoveMulti = this._onRemoveMulti.bind(this);
    this._onChangeMulti = this._onChangeMulti.bind(this);
    this._onAddList = this._onAddList.bind(this);
    this._onDeleteList = this._onDeleteList.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.getYearsOfEducationsOptions = this.getYearsOfEducationsOptions.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    // this._getPrmLevels = this._getPrmLevels.bind(this);
    this._getStudentPeriodSPPOptions = this._getStudentPeriodSPPOptions.bind(this);
    this.getPrmPayments = this.getPrmPayments.bind(this);
    this.getPrmPaymentsGeneral = this.getPrmPaymentsGeneral.bind(this);

    const { user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { levels_id, va_code, unit_code } = school_unit;
    this.state = {
      form: {
        value: {
          va_code,
          unit_code,
          levels: levels_id,
          organizations_id,
          total: 0,
          currents_year: '',
          academics_year: '',
          tabelpayments: [
            {
              payments_id: '',
              nominal: 0,
            },
          ],
        },
        error: {
          tabelpayments: [],
        },
      },
      param: {},
    };
  }

  componentDidMount() {
    const { user, location } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { organizations_id, school_unit, user_group } = user;
    const paramTypes = ['classrooms', 'levels'];

    if (user_group.name === 'pusat') {
      this._getParamOptionsAcademics('classrooms', {
        levels_id: data.levels_id,
        organizations_id,
        units_id: data.units_id,
      });
      this.setState(prevState => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            levels: data.levels_id,
            units_id: data.units_id,
          },
        },
      }));
    }
    paramTypes.forEach((type) => {
      this._getParamOptionsAcademics(type);
    });

    if (user_group.name == 'pusat') {
      this.getYearsOfEducationsOptions({ units_id: data.units_id });
    } else {
      this.getYearsOfEducationsOptions({ units_id: school_unit.id });
    }
    if (organizations_id == 3) {
      this.getPrmPayments();
    } else {
      this.getPrmPaymentsGeneral();
    }
  }

  _onFormChange(event) {
    const { user } = this.props;
    const { school_unit, organizations_id, user_group } = user;
    const { form } = this.state;
    const {
      tabelpayments, classrooms_id, nextyear, currents_year,
    } = form.value;

    const {
      name, value, dataset, checked, type,
    } = event.target;
    const {
      inputType = 'text',
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;

    if (name === 'classrooms_id' || name == 'currents_year') {
      // kosongkan siswa
      this.setState(prevState => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            students: [],
          },
        },
      }));
    }

    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;

      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
        newList = prevState.form.value[fieldName] || [];
        newListError = prevState.form.error[fieldName] || [];

        if (name === 'payments_id') {
          newList[arrayPosition].error_payments = '';
          { map(tabelpayments, (data, idx) => {
            if (data.payments_id == value) {
              formattedValue = '';
              newList[arrayPosition].error_payments = 'Nama pembayaran sudah dipilih';
            }
          }); }
        }

        if (name === 'nominal') {
          let toNum = value;
          do {
            toNum = toNum.replace('.', '');
          }
          while (toNum.indexOf('.') != -1);
          formattedValue = Number(toNum);
        }

        newList[arrayPosition][name] = formattedValue;
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray ? { [fieldName]: newListError } : { [name]: '' }),
          },
        },
      };
    }, () => {
      console.log(form.value);
      if (name === 'levels') {
        this._getParamOptionsAcademics('classrooms', { levels_id: value, organizations_id });
      }
      if (name === 'currents_year') {
        const param = this.state.param.periods;
        const periods_id = param.find(i => i.value == value) ? param.find(i => i.value == value).attributes.periods_id : '';

        this._getStudentPeriodSPPOptions({ units_id: user_group.name == 'pusat' ? [form.value.units_id] : [school_unit.id], filters: { classrooms_id: [classrooms_id], organizations_id, period: periods_id } });
      }
      if (name === 'classrooms_id') {
        const param = this.state.param.periods;
        const periods_id = param.find(i => i.value == currents_year) ? param.find(i => i.value == currents_year).attributes.periods_id : '';

        this._getStudentPeriodSPPOptions({ units_id: user_group.name == 'pusat' ? [form.value.units_id] : [school_unit.id], filters: { classrooms_id: [value], organizations_id, period: periods_id } });
      }
    });
  }

  _onRemoveMulti(selectedList, removedItem) {
    this._onFormChange({
      target: {
        name: removedItem,
        value: selectedList,
        dataset: {},
      },
    });
  }

  _onChangeMulti(value, name) {
    this._onFormChange({
      target: {
        name,
        value,
        dataset: {},
      },
    });
  }

  _onAddList(data) {
    const { form } = this.state;
    const { tabelpayments } = form.value;

    tabelpayments.push({
      payments_id: '',
      nominal: 0,
    });

    this.setState(prevState => ({
      form: {
        value: {
          ...prevState.form.value,
          tabelpayments,
        },
        error: {
          ...prevState.form.error,
        },
      },
    }));
  }

  _onDeleteList(idx) {
    this.setState((prevState) => {
      const list = prevState.form.value.tabelpayments;
      list.splice(idx, 1);
      return {
        ...prevState,
        tabelpayments: list,
      };
    });
  }

  async onSubmit() {
    const {
      history, handleSaveRutinClassrooms, handleSaveRutinClassroomsGeneral, user,
    } = this.props;
    const { organizations_id } = user;
    const { form } = this.state;
    const { value } = form;

    if (form.value.total < 0) {
      errorAlert({
        title: 'Total tidak boleh minus',
        errorMessage: 'Mohon di cek kembali',
      });
    } else {
      let canSaveA = true;
      const dataForm = form.value;
      const lengthdata = dataForm.tabelpayments.length;
      if (dataForm.currents_year && dataForm.levels && (dataForm.students) && lengthdata) {
        if (dataForm.students.length > 0) {
          map(dataForm.tabelpayments, (data, idx) => {
            if (!data.payments_id || !data.nominal) {
              canSaveA = false;
              errorAlert({
                title: 'Harap lengkapi data form',
                errorMessage: 'Bagian yang harus diisi ditandai dengan tanda bintang (*)',
              });
            } else if (data.nominal == 0) {
              canSaveA = false;
              errorAlert({
                title: 'Nominal Tidak Boleh "0"',
                errorMessage: 'Mohon hapus pembayaran yang tidak terpakai.',
              });
            }
          });
        }
      } else {
        canSaveA = false;
        errorAlert({
          title: 'Harap lengkapi data form',
          errorMessage: 'Bagian yang harus diisi ditandai dengan tanda bintang (*)',
        });
      }

      if (canSaveA) {
        if (organizations_id == 3) {
          await handleSaveRutinClassrooms(value);
          history.push('/dashboard/tagihan-siswa/create-invoice');
        } else {
          await handleSaveRutinClassroomsGeneral(value);
          history.push('/dashboard/tagihan-siswa/create-invoice');
        }
      }
    }
  }

  async getYearsOfEducationsOptions(filters = {}) {
    const { getYearsOfEducationsOptions } = this.props;
    const res = await getYearsOfEducationsOptions(filters);

    map(res, (data, idx) => {
      const date = new Date();
      const start_date = new Date(data.attributes.start_date);
      if (date > start_date) {
        // tahun ajaran selanjutnya
        if (res[idx + 1]) {
          this.setState(prevState => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                nextyear: res[idx + 1].value,
              },
            },
          }));
        }
      }
    });

    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
  }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user, location } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data, getdata } = state;
    const { organizations_id, school_unit, user_group } = user;
    const { levels_id } = school_unit;

    if (type === 'classes' || type === 'classrooms') {
      filters.organizations_id = organizations_id;
      if (user_group.name == 'pusat') {
        filters.units_id = data.units_id;
      } else {
        filters.units_id = school_unit.id;
      }
      // filters.levels_id = levels_id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  async _getPrmLevels(filters = {}) {
    const { getPrmLevels, user } = this.props;
    const { organizations_id, school_unit } = user;
    const res = await getPrmLevels(filters);
    filters.organizations_id = organizations_id;

    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        levels: res,
      },
    }));
  }

  async _getStudentPeriodSPPOptions(filters = {}) {
    const { getStudentPeriodSPPOptions } = this.props;
    const res = await getStudentPeriodSPPOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        student: res,
      },
    }));
  }

  async getPrmPayments() {
    const { getPrmPayments } = this.props;
    const res = await getPrmPayments();
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        prm_payments: res,
      },
    }));
  }

  async getPrmPaymentsGeneral() {
    const { getPrmPaymentsGeneral } = this.props;
    const res = await getPrmPaymentsGeneral();
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        prm_payments: res,
      },
    }));
  }

  render() {
    const { form, param } = this.state;
    const { tabelpayments, nextyear } = form.value;
    const { user } = this.props;
    const { organizations_id } = user;

    form.value.total = 0;
    { map(tabelpayments, (list, idx) => {
      if (list.payments_id && !isEmpty(param.prm_payments)) {
        list.is_discount = param.prm_payments.find(i => i.value == list.payments_id).is_discount;
        // if (list.payments_id == 42 || list.payments_id == 43) {
        if (list.is_discount == 1) {
          form.value.total -= Number(list.nominal);
        } else {
          form.value.total += Number(list.nominal);
        }
      }
    }); }

    if (form.value.total < 0) {
      form.error.total = 'Total minus.';
    } else {
      delete form.error.total;
    }

    form.value.currents_year = form.value.currents_year ? form.value.currents_year : nextyear;

    return (
      <div className="student-list">
        <div className="budget__title">
          <h1>Invoice {organizations_id == 3 ? 'SPP' : 'Rutin'} per Kelas </h1>
          <hr />
        </div>
        <form>
          <div className="result__content">
            <div className="nilai-kognitif__custom-form">
              <div className="kode-matpel__custom-form-row">
                <div className="kode-matpel__custom-form-row__field">
                  <Select
                    name="currents_year"
                    label="Tahun Ajaran *"
                    onChange={this._onFormChange}
                    data={param.periods}
                    placeholder="Pilihan"
                    value={form.value.currents_year || ''}
                    error={form.error.currents_year}
                    isRequired
                  />
                </div>
                <div className="kode-matpel__custom-form-column__field">
                  <Select
                    name="levels"
                    label="Pilih Unit"
                    placeholder="Pilihan"
                    data={param.levels}
                    onChange={this._onFormChange}
                    value={form.value.levels}
                    error={form.error.levels || ''}
                    disabled
                  />
                </div>
              </div>
              <div className="kode-matpel__custom-form-row">
                <div className="kode-matpel__custom-form-row__field">
                  {(form.value.levels) && (
                    <Select
                      placeholder="Pilih Kelas"
                      label="Kelas"
                      name="classrooms_id"
                      value={form.value.classrooms_id}
                      data={param.classrooms}
                      onChange={this._onFormChange}
                    />
                  )}
                </div>
                <div className="kode-matpel__custom-form-column__field" />
              </div>
              <br />
              <div className="kode-matpel__custom-form-row">
                <div className="kode-matpel__custom-form-column__field">
                  {(form.value.classrooms_id) && (
                    <>
                      <p>Siswa *</p>
                      <SelectMultiple
                        name="students"
                        style={{ width: '100%', fontSize: '25px' }}
                        options={param.student}
                        // disable	={form.value.classrooms ? false : true}
                        displayValue="label" // Property name to display in the dropdown options
                        showCheckbox
                        values={form.value.students}
                        errors={form.error.students}
                        onRemove={value => this._onRemoveMulti(value, 'students')}
                        onSelect={value => this._onChangeMulti(value, 'students')}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <br />
          <table className="manage-rapbs-plafon__form-table table-invoice">
            <thead>
              <tr>
                <th colSpan="2">Data *</th>
              </tr>
            </thead>
            <tbody>
              {map(tabelpayments, (list, idx) => (
                <tr key={`plafon_journal_data__${idx}`}>
                  <td>
                    <div className="kode-matpel__custom-form-row">
                      <div className="kode-matpel__custom-form-column__field">
                        <Select
                          label="Nama Pembayaran *"
                          name="payments_id"
                          onChange={this._onFormChange}
                          placeholder="Pilihan"
                          data={param.prm_payments}
                          value={list.payments_id}
                          error={list.error_payments}
                          // isRequired
                          data-input-array
                          arrayPosition={idx}
                          data-array-position={idx}
                          data-field-name="tabelpayments"
                        />
                      </div>
                      <div className="kode-matpel__custom-form-column__field" style={{ flexDirection: 'unset' }}>
                        <label style={{ paddingTop: '30px', paddingRight: '20px' }}>Rp.</label>
                        <Input
                          // type="number"
                          name="nominal"
                          label="Nominal *"
                          onChange={this._onFormChange}
                          value={list.nominal}
                          // error={form.error.nominal}
                          // isRequired
                          data-input-array
                          arrayPosition={idx}
                          data-array-position={idx}
                          data-field-name="tabelpayments"
                          isNumber
                        />
                      </div>
                    </div>

                  </td>
                  <td>
                    <Button onClick={() => this._onDeleteList(idx)} icon="icon-trash-o" />
                  </td>

                </tr>

              ))}
            </tbody>
            <tfoot>
              <tr className="manage-rapbs-plafon__add-more">
                <td colSpan={2}>
                  <div>
                    <Button icon="icon-plus" onClick={this._onAddList} />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <div className="kode-matpel__custom-form-row">
                      <div className="kode-matpel__custom-form-row__field" />

                      <div className="kode-matpel__custom-form-column__field" style={{ flexDirection: 'unset' }}>
                        <label style={{ paddingTop: '30px', paddingRight: '20px' }}>Rp.</label>
                        <Input
                          name="total"
                          label="Total"
                          onChange={this._onFormChange}
                          value={form.value.total}
                          isNumber
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td />
              </tr>
            </tfoot>
          </table>
          <br />
          <div className="student-list__header">
            <div className="student-list__button">
              <Button type="button" title="Simpan" onClick={this.onSubmit} />
            </div>
          </div>
        </form>
      </div>
    );
  }
}
CreateInvoiceKelas.propTypes = {
};
CreateInvoiceKelas.defaultProps = {
};
